export enum NavBarCyTags {
  NavbarMenuItems = 'menu',
  WalletLoginButton = 'button-login',
  WalletSignUpButton = 'button-signup',
  WalletConnectButton = 'button-connect-wallet'
}
export enum CommonCyTags {
  MarketPair = 'market-pair',
  MarketDropdown = 'market-dropdown',
  PercentageAmount = 'percentage-amount'
}

export enum MarketCyTags {
  MarketTrade = 'trade',
  MarketTicker = 'ticker',
  MarketType = 'market-type',
  HeaderLabel = 'header-label',
  MarketChain = 'market-chain',
  MarketsCard = 'markets-card',
  MarketVolume = 'token-volume',
  MarketBaseToken = 'base-token',
  MarketLastPrice = 'last-price',
  MarketQuoteToken = 'quote-token',
  MarketCardDenoms = 'card-denoms',
  MarketPriceChange = 'price-change',
  MarketSearch = 'market-search-field',
  MarketsCategoryType = 'category-type',
  NewMarketsDenoms = 'new-markets-denoms',
  TokenSelectorOptionsBaseToken = 'token-selector-options-base-token',
  TokenSelectorOptionsQuoteToken = 'token-selector-options-quote-token',
  AmountFieldTokenSelectorDropdown = 'amount-field-token-selector-dropdown'
}

export enum SwapCyTags {
  SwapForm = 'form',
  SwapSummaryRate = 'rate',
  SwapSummaryFees = 'fees',
  Swapbutton = 'swap-button',
  YouPayForm = 'you-pay-form',
  SwapHeaderLabel = 'header-label',
  BalanceString = 'balance-string',
  SwapSummaryRoute = 'summary-route',
  SwapSummaryMinOutput = 'min-output',
  WarningRateExpired = 'rate-expired',
  YouReceiveForm = 'you-receive-form',
  SwapSummaryExpectedOutput = 'exp-output',
  EnterAmountButton = 'enter-amount-button',
  TokenEstUsdPrice = 'token-estimated-usd-price',
  WarningAmountTooLow = 'amount-too-low-warning',
  SlippageSelectorSetting = 'slippage-selector-setting',
  WarningInsufficientbalance = 'insufficient-balance-error'
}

export enum TradeCyTags {
  Aggregation = 'aggregation',
  AggregationSelector = 'aggregation-selector'
}

export enum SpotMarketCyTags {
  TradeStats = 'trade-stats',
  ChartHeader = 'chart-header',
  SpotTradingSide = 'order-side',
  DetailsTotal = 'details-total',
  DetailsPrice = 'details-price',
  OrderDetails = 'order-details',
  OpenOrderQty = 'open-order-qty',
  SpotTradingMode = 'trading-mode',
  SpotTradingType = 'trading-type',
  DetailsAmount = 'details-amount',
  OrderbookGrid = 'orderbook-grid',
  OpenOrderSide = 'open-order-side',
  IUnderstandButton = 'i-understand',
  OpenOrderPrice = 'open-order-price',
  TradeStatsInfo = 'trade-stats-info',
  TokenBuyBalance = 'token-buy-balance',
  AdvancedSettings = 'advanced-settings',
  TokenSellBalance = 'token-sell-balance',
  OrderHistoryType = 'order-history-type',
  OrderHistorySide = 'order-history-side',
  OpenOrdersRow = 'open-orders-history-row',
  OrderHistoryPrice = 'order-history-price',
  OrderHistoryTotal = 'order-history-total',
  CancelOrderButton = 'cancel-order-button',
  OrderbookGridBuys = 'orderbook-grid-buys',
  OrderDetailsTable = 'order-details-table',
  LimitPriceInputField = 'input-field-limit',
  OpenOrderTotalAmt = 'open-order-total-amt',
  TradeStatsInfoVol = 'trade-stats-info-vol',
  TradeStatsInfoLow = 'trade-stats-info-low',
  OrderHistoryAmount = 'order-history-amount',
  OrderHistoryStatus = 'order-history-status',
  OrderbookGridSells = 'orderbook-grid-sells',
  SlippageInputField = 'slippage-input-field',
  SlippageWorstPrice = 'slippage-worst-price',
  OrderbookMarkPrice = 'orderbook-mark-price',
  OpenOrderFilledQty = 'open-order-filled-qty',
  DoNotShowAgainCheckbox = 'do-not-show-again',
  TradeStatsMarketSelector = 'market-selector',
  TradeStatsInfoHigh = 'trade-stats-info-high',
  DetailsStableAmount = 'details-stable-amount',
  OrderHistoryTrigger = 'order-history-trigger',
  DetailsMakerFeeRate = 'details-maker-fee-rate',
  DetailsEstFeeRebate = 'details-est-fee-rebate',
  TradeStatsInfoPrice = 'trade-stats-info-price',
  OrderbookViewOptions = 'orderbook-view-options',
  OrderDetailsDropdownOptions = 'dropdown-options',
  OpenOrderUnfilledQty = 'open-order-unfilled-qty',
  OrderHistoryTimestamp = 'order-history-timestamp',
  LimitAmountInputField = 'input-field-limit-amount',
  DetailsMakerTakerRate = 'details-maker-taker-rate',
  OpenOrderMarketTicker = 'open-order-market-ticker',
  OrderbookMidMarkPrice = 'orderbook-mid-mark-price',
  OrderDetailsDropDown = 'order-trade-details-dropdown',
  ExperimentalMarketLabel = 'experimental-market-label',
  AdvancedSettingsSlippage = 'advanced-settings-slippage',
  AdvancedSettingsPostOnly = 'advanced-settings-post-only',
  OrderHistoryMarketTicker = 'order-history-market-ticker',
  OpenOrderTotalAmtTokenSymbol = 'open-order-total-amt-token-symbol',
  AdvancedSettingsBypassWarning = 'advanced-settings-bypass-price-warning'
}

export enum PerpetualMarketCyTags {
  DetailsQty = 'details-qty',
  DetailsFee = 'details-fee',
  DetailsTotal = 'details-total',
  TpSlCheckbox = 'tp-sl-checkbox',
  LeverageError = 'leverage-error',
  DetailsMargin = 'details-margin',
  OpenPosAmount = 'open-pos-amount',
  OpenPosMargin = 'open-pos-margin',
  TradeDirection = 'trade-direction',
  TpSlAddButton = 'tpsl-add-button',
  OpenOrdersSide = 'open-orders-side',
  DetailsAvgPrice = 'details-avg-price',
  OpenPosLeverage = 'open-pos-leverage',
  OpenOrdersPrice = 'open-orders-price',
  OpenOrdersTotal = 'open-orders-total',
  TradeHistoryFee = 'trade-history-fee',
  AvailableBalance = 'available-balance',
  AdvancedSettings = 'advanced-settings',
  OpenEntryPrice = 'open-pos-entry-price',
  OrderHistorySide = 'order-history-side',
  OpenOrdersAmount = 'open-orders-amount',
  OpenOrdersFilled = 'open-orders-filled',
  OpenPosTotalValue = 'open-pos-total-val',
  OrderHistoryPrice = 'order-history-price',
  OrderHistoryTotal = 'order-history-total',
  TradeHistoryPrice = 'trade-history-price',
  TradeHistoryTotal = 'trade-history-total',
  TpSlEditFormMarkPrice = 'tpsl-mark-price',
  TpSlFormTradeDirection = 'tpsl-direction',
  TpSlConfirmButton = 'tpsl-confirm-button',
  LeverageInputField = 'leverage-input-field',
  OrderHistoryAmount = 'order-history-amount',
  OpenOrdersUnfilled = 'open-orders-unfilled',
  OpenOrdersLeverage = 'open-orders-leverage',
  TradeHistoryAmount = 'trade-history-amount',
  SlippageInputField = 'slippage-input-field',
  SlippageWorstPrice = 'slippage-worst-price',
  TpSlEditFormEntryPrice = 'tpsl-entry-price',
  StopLossInputField = 'stop-loss-input-field',
  DerivativeTradeType = 'derivative-trade-type',
  TpSlEditFormEstLiqPrice = 'tpsl-est-liq-price',
  OpenPosMarketTicker = 'open-pos-market-ticker',
  DetailsTotalNotional = 'details-total-notional',
  OrderDetailsDropdown = 'order-details-dropdown',
  TakeProfitInputField = 'take-profit-input-field',
  LimitpriceInputField = 'limit-price-input-field',
  OrderDetailsDropdownOptions = 'dropdown-options',
  TpSlEditFormTotalQtySize = 'tpsl-total-qty-size',
  OpenPosUnrealizedPnl = 'open-pos-unrealized-pnl',
  OpenOrdersLeverageNa = 'open-orders-leverage-na',
  DetailsMakerTakerRate = 'details-maker-taker-fee',
  OrderHistoryTimeStamp = 'order-history-timestamp',
  TradeHistoryTimestamp = 'trade-history-timestamp',
  LimitAmountInputField = 'limit-amount-input-field',
  OpenPosTradeDirection = 'open-pos-trade-direction',
  OrderHistoryOrderType = 'order-history-order-type',
  TradeHistoryTradeType = 'trade-history-trade-type',
  TradeHistoryTradeSide = 'trade-history-trade-side',
  PositionsTableTPValue = 'positions-table-tp-value',
  PositionsTableSLValue = 'positions-table-sl-value',
  TriggerPriceInputField = 'trigger-price-input-field',
  TpSlFormStopLossQuantity = 'tpsl-stop-loss-quantity',
  OpenOrdersMarketTicker = 'open-orders-market-ticker',
  OpenPosClosePosPrice = 'open-pos-close-positon-price',
  TpSlFormStopLossErrorMessage = 'tpsl-stop-loss-error',
  OpenPosLiquidationPrice = 'open-pos-liquidation-price',
  OpenPosClosePosLimit = 'open-pos-close-position-limit',
  OpenPosClosePositionQty = 'open-pos-close-positon-qty',
  OrderHistoryOrderStatus = 'order-history-order-status',
  OpenPosClosePosition = 'open-pos-close-position-market',
  OrderHistoryMarketTicker = 'order-history-market-ticker',
  TradeHistoryMarketTicker = 'trade-history-market-ticker',
  AdvancedOrdersTablePrice = 'advanced-orders-table-price',
  TpSlFormTakeProfitQuantity = 'tpsl-take-profit-quantity',
  TpSlFormTakeProfitErrorMessage = 'tpsl-take-profit-error',
  TpSlFormTakeProfitQtyError = 'tpsl-take-profit-qty-error',
  AdvancedOrdersTableAmount = 'advanced-orders-table-amount',
  PartialClosePositionOption = 'partial-close-position-option',
  TradeStatsInfoFundingRate = 'trade-stats-info-funding-rate',
  TpSlFormStopLossQtyErrorMessage = 'tpsl-stop-loss-qty-error',
  DetailsEstLiquidationPrice = 'details-est-liquidation-price',
  TpSlFormStopLossTriggerPrice = 'tpsl-stop-loss-trigger-price',
  PositionsTableAddTpSlButton = 'positions-table-add-tpsl-button',
  PositionsTableEditTpSlButton = 'positions-table-edit-tpsl-button',
  TpSlEditFormTakeProfitTriggerPrice = 'tpsl-take-profit-trigger-price',
  AdvancedOrdersTableMarketTicker = 'advanced-orders-table-market-ticker',
  AdvancedSettingsPostOnlyCheckbox = 'advanced-settings-post-only-checkbox',
  AdvancedOrdersTableOrderDirection = 'advanced-orders-table-order-direction',
  PositionsTableClosePositionButton = 'positions-table-close-position-button',
  AdvancedSettingsReduceOnlyCheckbox = 'advanced-settings-reduce-only-checkbox',
  AdvancedSettingsByPassPriceWarningCheckbox = 'advanced-settings-bypass-price-warning-checkbox'
}

export enum PortfolioCyTags {
  AssetSearch = 'asset-search',
  BalanceTotalValue = 'total-value',
  BalanceTokenSymbol = 'token-symbol',
  BalanceTotalAmount = 'total-amount',
  PortfolioMenuItems = 'portfolio-menu',
  BalanceUnrealisedPnl = 'unrealised-pnl',
  SubAccountTotalBalance = 'total-balance',
  SubAccountDropdown = 'sub-account-dropdown',
  BalanceAvailableAmount = 'available-amount',
  BalanceInUseOrReservedAmount = 'use-reserved-amount',
  SubAccountDropdownOptions = 'sub-account-dropdown-options'
}

export enum VaultsCyTags {
  tvl = 'tvl',
  apy = 'apy',
  title = 'title',
  denoms = 'denoms'
}

export enum LeaderBoardCyTags {
  title = 'title',
  rankPnl = 'rank-pnl',
  duration = 'duration',
  pageName = 'page-name',
  rankLogo = 'rank-logo',
  timestamp = 'timestamp',
  rankAddress = 'rank-address',
  startTrading = 'start-trading'
}

export enum SpotTradingBotsCyTags {
  BaseDenomInputField = 'base-denom-input-field',
  QuoteDenomInputField = 'quote-denom-input-field',
  GridNumber = 'grid-number',
  NumberOfGridsLabel = 'number-of-grids-label',
  NumberOfGridsValue = 'number-of-grids-value',
  GridDetailsInitialQuoteSymbol = 'initial-quote-amount-symbol',
  GridDetailsInitialQuoteAmount = 'initial-quote-amount-value',
  GridDetailsInitialBaseSymbol = 'initial-base-amount-symbol',
  GridDetailsInitialBaseAmount = 'initial-base-amount-value',
  AdjustModal = 'adjust-modal'
}
